/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type NexonLwWalletBalanceTrackerRequest = {
    periodType?: NexonLwWalletBalanceTrackerRequest.periodType;
};

export namespace NexonLwWalletBalanceTrackerRequest {

    export enum periodType {
        D7 = 'D7',
        D30 = 'D30',
        D180 = 'D180',
        ALL = 'ALL',
    }


}

